import { ButtonBasic, ViewSwitch, InputDynamicWidth, DropDownSelector } from "@lk-gtcom/ecomlab-components";
import { useEffect } from "react";
import add_icon from './img/add_icon.svg'
import { ButtonWithIcon } from "../../../components/Buttons/ButtonWithIcon/ButtonWithIcon";
import arrow_right from './img/arrow-right.svg'
import arrow_left from './img/arrow-left.svg'
import { useNavigate } from "react-router-dom";
import { DateBox } from "../../../components/DateBox/DateBox";
import { useLocation } from "react-router-dom";

const tab_btn = [
    {
        label: '1 Д',
        value: 'day'
    },
    {
        label: '7 Д',
        value: 'week'
    },
    {
        label: '1 M',
        value: 'month'
    }
]

const options_prop = [
    {
        label: 'Мероприятия',
        value: 1
    },
    {
        label: 'Задачи',
        value: 2
    }
]

const CalendarToolBarTop = ({
    selectedPeriod,
    setSelectedPeriod,
    startDate,
    currentDate,
    setStartDate,
    setCurrentDate,
    setEventInfo,
    setReadOnly,
    setAddEvent,
    setIsModal,
    selectView,
    refHeaderTop,
    setSelectView,
    // Фильтры
    search,
    setSearch,
    selectedTypeEvent,
    setSelectedTypeEvent,
    setIsModalFields
}) => {

    const startMonth = new Date(startDate.getTime()).getMonth();
    const endMonth = new Date(startDate.getTime() + 86400000 * 4).getMonth();
    const monthList = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
    const year = new Date(startDate.getTime()).getFullYear();
    const weekdayNames = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
    const location = useLocation();

    const currentDay = currentDate.getDay();
    const navigate = useNavigate()

    // Функция для расчета смещения в зависимости от периода
    const getPeriodOffset = () => {
        switch (selectedPeriod.value) {
            case 'day':
                return 86400000; // 1 день в миллисекундах
            case 'week':
                return 86400000 * 7; // 7 дней
            case 'month':
                return 86400000 * 30; // Примерно месяц (30 дней)
            default:
                return 86400000;
        }
    };

    // Функция для перехода к следующему периоду
    const goToNextPeriod = () => {
        const offset = getPeriodOffset();
        if (selectedPeriod.value === 'day') {
            const newStartDate = new Date(startDate.getTime() + offset);
            setStartDate(newStartDate);
            setCurrentDate(newStartDate);
        } else {
            setStartDate(new Date(startDate.getTime() + offset));
        }
    };

    // Функция для перехода к предыдущему периоду
    const goToPrevPeriod = () => {
        const offset = getPeriodOffset();
        if (selectedPeriod.value === 'day') {
            const newStartDate = new Date(startDate.getTime() - offset);
            setStartDate(newStartDate);
            setCurrentDate(newStartDate);
        } else {
            setStartDate(new Date(startDate.getTime() - offset));
        }
    };

    const currentMonths = `${monthList[startMonth]} ${startMonth !== endMonth ? '- ' + monthList[endMonth] : ''} ${year}`

    // Восстановление selectedPeriod при перезагрузке
    useEffect(() => {
        const path = location.pathname;
        if (path.includes('/day')) {
            setSelectedPeriod({ label: 'День', value: 'day' });
        } else if (path.includes('/week')) {
            setSelectedPeriod({ label: '7 Д', value: 'week' });
        } else if (path.includes('/month')) {
            setSelectedPeriod({ label: 'Месяц', value: 'month' });
        }
    }, [location]);

    return (
        <div className='calendar__filters' ref={refHeaderTop}>
            <div className="calendar__filters-left">
                <ButtonWithIcon
                    green
                    icon={add_icon}
                    size='m'
                    onClick={(e) => {
                        setCurrentDate(new Date())
                        setEventInfo({
                            dateFrom: new Date(),
                            dateTo: new Date().getTime() + 3600000
                        })
                        setReadOnly(false)
                        setAddEvent(true)
                        setIsModal(true)
                    }}
                />

                <div className='calendar__btn-tab-group'>
                    {tab_btn.map((el) => {
                        return <button
                            key={el.value}
                            className={selectedPeriod.value == el.value ? 'calendar__btn-range_active' : 'calendar__btn-range'}
                            onClick={(e) => {
                                setSelectedPeriod(el)
                                navigate(`/calendar/${el?.value}`)
                            }}
                        >{el.label}</button>
                    })}
                </div>

                <>
                    <div className='btn-toolbar-box'>
                        <ButtonWithIcon
                            violet
                            icon={arrow_left}
                            round
                            size="m"
                            onClick={goToPrevPeriod}
                        />

                        <DateBox
                            // disabled={check}
                            size='s'
                            startDate={startDate}
                            description={`${monthList[startMonth]} ${startMonth !== endMonth ? '- ' + monthList[endMonth] : ''} ${year}`}
                            setStartDate={(e) => {
                                setStartDate(e);
                            }}
                        />

                        <ButtonWithIcon
                            violet
                            icon={arrow_right}
                            round
                            size="m"
                            onClick={goToNextPeriod}
                        />
                    </div>

                    <div className='calendar__date-list'>
                        <ButtonWithIcon
                            violet
                            round
                            size="m"
                            icon={arrow_left}
                            onClick={() => {
                                const newStartDate = new Date((startDate.getTime() - 86400000))
                                setStartDate(newStartDate)
                                setCurrentDate(newStartDate)
                            }}
                        />

                        <div className='calendar__date-round'>
                            <p className='calendar__date-round_week'>{weekdayNames[currentDay]}</p>
                            <div className='number-box number-box_day'>
                                <p className='text_number'>{startDate.getDate()}</p>
                            </div>
                        </div>

                        <ButtonWithIcon
                            violet
                            icon={arrow_right}
                            round
                            size="m"
                            onClick={() => {
                                const newStartDate = new Date((startDate.getTime() + 86400000))
                                setStartDate(newStartDate)
                                setCurrentDate(newStartDate)
                            }}
                        />
                    </div>
                </>

                <ButtonBasic
                    lilac
                    text='Сегодня'
                    onClick={() => {
                        setCurrentDate(new Date())
                        setStartDate(new Date())
                    }}
                />

                <ButtonBasic
                    blue
                    text='+ Создать поля'
                    onClick={() => {
                        setIsModalFields(true)
                    }}
                />
            </div>

            <div className="calendar__filters-right">
                <DropDownSelector
                    options_prop={options_prop}
                    state={selectedTypeEvent}
                    setState={setSelectedTypeEvent}
                    placeholder="Тип события"
                    positionMenu
                    defaultValue={[{ label: 'Все', value: 'all' }]}
                    position='right'
                    multi
                />

                <InputDynamicWidth
                    position='left'
                    maxWidth='100%'
                    onChange={(e) => setSearch(e)}
                    placeholder='Ключевая фраза'
                />

                {selectedPeriod.value == 'month' &&
                    <ViewSwitch
                        tileLong={false}
                        calendar
                        tile={false}
                        selectView={selectView}
                        setSelectView={(e) => setSelectView(e)}
                    />}
            </div>
        </div>
    );
}

export default CalendarToolBarTop;